import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RegistrationTypeComponent } from './registration-type.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.registration-type', {
            url: '/registration-type',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Registration Type'
            },
            ncyBreadcrumb: {
                label: 'Tipo Account'
            },
            params: {
                activationCode: ''
            },
            'views': {
                'multiContentRegistration': {
                    template: '<registration-type flex="100"></registration-type>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RegistrationTypeModule: string = ng
    .module('registration-type', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('registrationType', RegistrationTypeComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration-type/registration-type.module.ts